import { translate } from '@core/i18n/window-language';
import {
    BOUND_POSITION_ATTRIBUTE,
    BOUND_POSITIONS,
    TOOLTIP_POSITION,
} from '@components/TooltipComponent/CONSTANTS';

/**
 * Update tooltip content with translated text
 * @param {HTMLParagraphElement} tooltipDropdownContentText - The tooltip text element
 * @returns {void}
 */
export function updateTooltipContent(tooltipDropdownContentText) {
    if (tooltipDropdownContentText) {
        tooltipDropdownContentText.innerText = translate('tooltip.premium');
    }
}

/**
 * Apply tooltip positioning based on position and flex grow values
 * @param {HTMLDivElement} tooltipImgsContentContainer - The tooltip container element
 * @param {string} tooltipPosition - The tooltip position
 * @param {number} customFlexGrow - The custom flex grow value
 * @returns {void}
 */
export function applyTooltipPositioning(
    tooltipImgsContentContainer,
    tooltipPosition,
    customFlexGrow,
) {
    if (!tooltipImgsContentContainer) return;

    switch (tooltipPosition) {
        case TOOLTIP_POSITION.BOTTOM_RIGHT:
            tooltipImgsContentContainer.style.right = `${Math.min(
                customFlexGrow * 0.5,
                40,
            )}%`;
            break;
        case TOOLTIP_POSITION.BOTTOM_LEFT:
            tooltipImgsContentContainer.style.left = `${Math.min(
                customFlexGrow * 0.5,
                40,
            )}%`;
            tooltipImgsContentContainer.style.right = 'unset';
            break;
        case TOOLTIP_POSITION.TOP_LEFT:
            tooltipImgsContentContainer.style.right = '45px';
            tooltipImgsContentContainer.style.setProperty('top', '0', 'important');
            break;
        case TOOLTIP_POSITION.TOP_RIGHT:
            tooltipImgsContentContainer.style.right = 'unset';
            tooltipImgsContentContainer.style.left = '45px';
            tooltipImgsContentContainer.style.setProperty('top', '0', 'important');
            tooltipImgsContentContainer.setAttribute(
                BOUND_POSITION_ATTRIBUTE,
                BOUND_POSITIONS.RIGHT,
            );
            break;
        default:
            break;
    }
}
